export default {
    intro:              "Prispôsobte si, ako AI generuje popisy vašich položiek.",
    tone_label:         "Tón popisu",
    tone_selling:       "Predajný",
    tone_professional:  "Profesionálny",
    tone_friendly:      "Priateľský",
    tone_luxury:        "Luxusný / Prémiový",
    length_label:       "Dĺžka popisu",
    length_short:       "Krátky",
    length_medium:      "Stredný",
    length_long:        "Dlhší",
    include_label:      "Zahrnúť v popise",
    benefits_toggle:    "Výhody produktu/služby",
    benefits_tooltip:   "AI automaticky identifikuje a zdôrazní kľúčové výhody vášho produktu alebo služby v popise.",
    cta_toggle:         "Výzvu k akcii (call-to-action)",
    cta_tooltip:        "Na koniec popisu pridá výzvu k akcii, napr. 'Objednajte ešte dnes!' alebo 'Kontaktujte nás pre viac informácií.'",
    custom_label:       "Vlastné inštrukcie",
    custom_optional:    "(voliteľné)",
    use_last_used:      "Použiť posledné použité",
    custom_placeholder: "Napr.: Zameraj sa na ekológiu, spomeň záruku, použi formálny jazyk...",
    reset_defaults:     "Obnoviť predvolené",
    generating:         "Generujem...",
    generate_btn:       "Vygenerovať popis cez AI",
    save_error:         "Nepodarilo sa uložiť nastavenia",
};
